webpackJsonp([104101334113578],{

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DirectionsButtonModule = __webpack_require__(180);
	
	var _DirectionsButtonModule2 = _interopRequireDefault(_DirectionsButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DIRECTION_URL = 'https://www.google.com/maps/dir/?api=1&destination=10510+Stone+Ave+N,+Seattle,+WA+98133';
	
	var DirectionsButton = function DirectionsButton() {
	  return _react2.default.createElement(
	    'a',
	    {
	      className: _DirectionsButtonModule2.default.component,
	      href: DIRECTION_URL,
	      target: '_blank',
	      rel: 'noopener noreferrer'
	    },
	    'Get Directions'
	  );
	};
	
	exports.default = DirectionsButton;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-DirectionsButton----DirectionsButton-module---component---2y7Ni"};

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Nav = __webpack_require__(120);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _logo = __webpack_require__(250);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _HeaderModule = __webpack_require__(181);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'header',
	    { className: (_HeaderModule2.default.component + ' ' + className).trim() },
	    _react2.default.createElement(
	      'div',
	      { className: _HeaderModule2.default.navContainer },
	      _react2.default.createElement(
	        'div',
	        { className: _HeaderModule2.default.brandContainer },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _HeaderModule2.default.brand, to: '/' },
	          _react2.default.createElement(_logo2.default, { className: _HeaderModule2.default.logo }),
	          _react2.default.createElement(
	            'span',
	            { className: _HeaderModule2.default.brandName },
	            'New Covenant Baptist Church'
	          )
	        )
	      ),
	      _react2.default.createElement(_Nav2.default, null)
	    )
	  );
	};
	
	Header.defaultProps = {
	  className: ''
	};
	
	Header.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-Header----Header-module---component---2wP_t","navContainer":"src-components-Header----Header-module---navContainer---17soM","brandContainer":"src-components-Header----Header-module---brandContainer---XbKCu","brand":"src-components-Header----Header-module---brand---34r6-","brandName":"src-components-Header----Header-module---brandName---39hpj","logo":"src-components-Header----Header-module---logo---2Zf4H"};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _NavModule = __webpack_require__(182);
	
	var _NavModule2 = _interopRequireDefault(_NavModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      showLinks: false
	    }, _this.handleMouseDown = function (event) {
	      if (_this.navRef && !_this.navRef.contains(event.target) && _this.hamburgerMenuRef && !_this.hamburgerMenuRef.contains(event.target)) {
	        _this.setState(function (_ref) {
	          var showLinks = _ref.showLinks;
	          return showLinks ? { showLinks: false } : null;
	        });
	      }
	    }, _this.handleHamburgerMenuClick = function (event) {
	      _this.setState(function (_ref2) {
	        var showLinks = _ref2.showLinks;
	        return {
	          showLinks: !showLinks
	        };
	      });
	    }, _this.handleLinkClick = function () {
	      return _this.setState({ showLinks: false });
	    }, _this.setNavRef = function (ref) {
	      return _this.navRef = ref;
	    }, _this.setHamburgerMenuRef = function (ref) {
	      return _this.hamburgerMenuRef = ref;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('mousedown', this.handleMouseDown);
	  };
	
	  Nav.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('mousedown', this.handleMouseDown);
	  };
	
	  Nav.prototype.render = function render() {
	    var showLinks = this.state.showLinks;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (_NavModule2.default.component + ' ' + (showLinks ? _NavModule2.default.navbarToggleShow : '')).trim()
	      },
	      _react2.default.createElement(
	        'button',
	        {
	          ref: this.setHamburgerMenuRef,
	          className: _NavModule2.default.navbarToggle,
	          'aria-label': 'Menu',
	          onClick: this.handleHamburgerMenuClick
	        },
	        _react2.default.createElement('span', { className: _NavModule2.default.hamburgerLine }),
	        _react2.default.createElement('span', { className: _NavModule2.default.hamburgerLine }),
	        _react2.default.createElement('span', { className: _NavModule2.default.hamburgerLine })
	      ),
	      _react2.default.createElement(
	        'nav',
	        { ref: this.setNavRef, className: _NavModule2.default.navbar },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about/', onClick: this.handleLinkClick },
	              'About'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/ministries/', onClick: this.handleLinkClick },
	              'Ministries'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/events/', onClick: this.handleLinkClick },
	              'Events'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/devotional/', onClick: this.handleLinkClick },
	              'Devotional'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/location/', onClick: this.handleLinkClick },
	              'Location'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/giving/', onClick: this.handleLinkClick },
	              'Giving'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-Nav----Nav-module---component---nrEnJ","navbarToggle":"src-components-Nav----Nav-module---navbarToggle---aqzei","hamburgerLine":"src-components-Nav----Nav-module---hamburgerLine---2P-RU","navbar":"src-components-Nav----Nav-module---navbar---faogX","navbarToggleShow":"src-components-Nav----Nav-module---navbarToggleShow---2uWvW"};

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bible.5ea54a66.jpg";

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Logo (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.logo{fill:#00547F;}\n"),React.createElement("path",{"className":"logo","d":"M70.4,19.1c4.5,2.3,20.7,8,36.4,10.3c14.6,2.1,26.4-2.4,37.2-7.2c0,0-17.5,20.8-40.9,20.2\n\tc-22.2-0.5-37.1-15.8-57.9-20c-18-3.7-45.2,7.7-45.2,7.7s22-14.9,41.7-17.1c0,0-14.4-16.2-34.9-6.3c0,0,14.9-12.4,30.5-4.3\n\tc10.5,5.5,15.6,9,26,9c0,0,20.4,0.4,32.7-8.3C96.1,3.2,87.4,15.1,70.4,19.1z","key":1})]);
	}
	
	Logo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 144 42","style":{"enableBackground":"new 0 0 144 42"},"xmlSpace":"preserve"};
	
	module.exports = Logo;
	
	Logo.default = Logo;


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.indexPageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(119);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _DirectionsButton = __webpack_require__(118);
	
	var _DirectionsButton2 = _interopRequireDefault(_DirectionsButton);
	
	var _bible = __webpack_require__(399);
	
	var _bible2 = _interopRequireDefault(_bible);
	
	var _indexModule = __webpack_require__(333);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  var page = data.markdownRemark;
	  var _page$frontmatter = page.frontmatter,
	      main = _page$frontmatter.main,
	      intro = _page$frontmatter.intro,
	      worshipServiceInfo = _page$frontmatter.worshipServiceInfo,
	      keyVerse = _page$frontmatter.keyVerse;
	  var heading = worshipServiceInfo.heading,
	      time = worshipServiceInfo.time,
	      location = worshipServiceInfo.location,
	      room = worshipServiceInfo.room,
	      streetAddress = worshipServiceInfo.streetAddress,
	      city = worshipServiceInfo.city,
	      state = worshipServiceInfo.state,
	      zipCode = worshipServiceInfo.zipCode;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _indexModule2.default.component },
	    _react2.default.createElement(
	      'main',
	      { className: _indexModule2.default.main },
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.toast },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Join us Wednesdays in July for ',
	          _react2.default.createElement(
	            'a',
	            { href: '/events' },
	            'Bible Study & Fellowship!'
	          )
	        )
	      ),
	      _react2.default.createElement(_Header2.default, { className: _indexModule2.default.header }),
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.mainContent },
	        _react2.default.createElement(
	          'h1',
	          { className: _indexModule2.default.title + ' ' + _indexModule2.default.fadeInDown },
	          main.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _indexModule2.default.lead + ' ' + _indexModule2.default.fadeInUp },
	          main.lead
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'intro' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.introContent },
	          _react2.default.createElement(
	            'h1',
	            null,
	            intro.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            intro.content
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'service-info', className: _indexModule2.default.serviceInfo },
	      _react2.default.createElement(
	        'div',
	        { className: 'container ' + _indexModule2.default.serviceInfoContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.imageContainer },
	          _react2.default.createElement('img', { className: _indexModule2.default.serviceInfoImage, src: _bible2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.serviceInfoContent },
	          _react2.default.createElement(
	            'h1',
	            null,
	            heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Sundays at ',
	            time
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            location,
	            _react2.default.createElement('br', null),
	            room && '(' + room + ')',
	            room && _react2.default.createElement('br', null),
	            streetAddress,
	            _react2.default.createElement('br', null),
	            city,
	            ', ',
	            state,
	            ', ',
	            zipCode
	          ),
	          _react2.default.createElement(_DirectionsButton2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'key-verse' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.keyVerseContent },
	          _react2.default.createElement(
	            'h1',
	            { className: _indexModule2.default.verse },
	            '"',
	            keyVerse.verse,
	            '"'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _indexModule2.default.reference },
	            keyVerse.reference
	          )
	        )
	      )
	    )
	  );
	};
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexPage;
	var indexPageQuery = exports.indexPageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-templates----index-module---component---3NDUg","toast":"src-templates----index-module---toast---3eXbB","main":"src-templates----index-module---main---1UnV-","header":"src-templates----index-module---header---1FuK9","mainContent":"src-templates----index-module---mainContent---wZV0I","title":"src-templates----index-module---title---3a0Hn","lead":"src-templates----index-module---lead---TNLHT","logo":"src-templates----index-module---logo---17vIE","introContent":"src-templates----index-module---introContent---2uSwl","serviceInfo":"src-templates----index-module---serviceInfo---1JSZB","serviceInfoContainer":"src-templates----index-module---serviceInfoContainer---1njf-","imageContainer":"src-templates----index-module---imageContainer---2PRVp","serviceInfoImage":"src-templates----index-module---serviceInfoImage---2_2G7","serviceInfoContent":"src-templates----index-module---serviceInfoContent---2X1Q0","keyVerseContent":"src-templates----index-module---keyVerseContent---30wE9","verse":"src-templates----index-module---verse---3hKIm","reference":"src-templates----index-module---reference---2i-vK","fadeInDown":"src-templates----index-module---fadeInDown---3-LNy","fadeInUp":"src-templates----index-module---fadeInUp---2BPrq"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-91d7d9f9a2421fd5c059.js